<template>
    <div>
        <div class="flex flex-row text-gray-500 items-center mt-2 ">
            <p
                class="text-sm"
            >
                {{ title }}
            </p>
            <svg
                v-if="!disabled"
                @click="startEdit"
                class="w-4 h-4 ml-2 hover:text-gray-400 cursor-pointer" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 20 20" fill="currentColor">
                <path
                    d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"/>
            </svg>
        </div>
        <p
            v-if="!editing"
            :class="[wrapType ? wrapType : 'truncate']"
            class="text-gray-800 mt-1 py-1"
        >
            {{ shortValue }}
        </p>
        <input
            :value="value"
            ref="input"
            @blur="baseEditing = false"
            @keyup.enter="baseEditing = false"
            @change="e => $emit('change', e.target.value)"
            @input="e => $emit('input', e.target.value)"
            class="mt-2 w-5/6 py-0 px-1 block border-gray-300 rounded-md focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
            type="text"
            v-show="editing"
        />

        <div class="text-red-400 text-sm" v-if="errors?.length">
            {{ errors?.join(', ')}}
        </div>
    </div>
</template>

<script>
export default {
    name: "editable-field",
    props: {
        title: String,
        value: String,
        disabled: Boolean,
        wrapType: String,
        errors: Array,
    },
    data(){
        return {
            baseEditing: false
        }
    },
    methods: {
        startEdit(){
            this.baseEditing = true;
            this.$nextTick(() => this.$refs.input.focus());
        }
    },
    computed:{
        shortValue(){
            const cutOff = 15;
            if(this.value) {
                if(this.value.length > cutOff && !this.wrapType) return this.value.substr(0, cutOff) + '...';
                else return this.value;
            }
            else return ""
        },
        editing(){
            return this.baseEditing && !this.disabled;
        }
    }
}
</script>

